<template>
  <mu-card id="search-panel">
    <form novalidate @submit.prevent="submitForm()">
      <mu-card-header
        titleClass="blueTitle largeTitle"
        :title="$t('message.searchText')"
      ></mu-card-header>
      <mu-card-text>
        <mu-paper>
          <mu-text-field
            v-validate
            v-model="searchTerm"
            :data-vv-rules="'required'"
            data-vv-name="search"
            data-vv-as="search"
            class="paperSearch"
            :underlineShow="false"
            icon="search"
            :hintText="$t('message.discussionSearchHintText')"
            fullWidth>
          </mu-text-field>
        </mu-paper>
        <button type="submit" style="display: none"></button>
        <mu-raised-button
          :disabled="isSearching || !searchTerm.length"
          @click.native="submitForm()"
          primary
          :label="isSearching ? $t('message.searchingText') : $t('message.searchText')"
          fullWidth
          class="searchButton"
        ></mu-raised-button>
      </mu-card-text>
    </form>
  </mu-card>
</template>
<script>

  export default {
    name: 'search-questions',
    data() {
      return {
        searchTerm: ""
      }
    },
    props: {
      isSearching: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.$router.replace({
                name: 'QuestionsIndex',
                query: {
                  type: 'SEARCH',
                  page: 1,
                  per_page: 15,
                  q: self.searchTerm
                }
              })
            }
          })
      }
    }
  }
</script>
<style lang="less">
  #search-panel {
    .mu-card-header {
      padding-bottom: 0;
    }
    .paperSearch {
      background-color: #FAFAFA;
      margin: 0;
      padding-bottom: 7px;
    }
    .mu-text-field.paperSearch.has-icon.full-width {
      min-height: initial;
      .mu-text-field-content {
        padding-bottom: 0;
      }
    }
    .mu-text-field-hint {
      line-height: 37px;
    }
    .mu-paper {
      margin-bottom: 16px;
    }
    .searchButton {
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      text-transform: none;
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// SearchQuestions.vue?5f781229